import style from "./ItemTeam.module.css";
import React from "react";
import {apiUrl} from "../../../model";

export function ItemTeam({ team }) {
    return (<tr className={style.item}><td><img alt={""} src={`${apiUrl}/${team.icon}`} style={{maxWidth: 50, maxHeight: 50}}/></td><td className={style.team}>{team.name}</td><td className={style.points}>{team.nbPoints}</td></tr>);
}